var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"vkbutton",class:[{plain: _vm.plain, disabled: _vm.disabled, loading: _vm.loading, round: _vm.round}, _vm.size],attrs:{"href":_vm.href},on:{"click":_vm.onClick}},[_c('i',{staticClass:"vkloading"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }